import React from 'react'
import Table from 'react-bootstrap/Table'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import SVGIcon from 'reusableComponents/SVGIcon'
import { ReactComponent as Pencil } from 'assets/svg/pencil.svg'
import { colors } from 'globalStyles'
import CheckMark from 'reusableComponents/CheckMark'

const StyledRow = styled.tr`
  text-align: left;
  height: 56px; /* Increases row height for better tap targets */
  vertical-align: middle;
`

const StyledSpan = styled.span`
  font-weight: 600;
  font-size: 16px;
`

const StyledFullNameSpan = styled.span`
  font-weight: 600;
  font-size: 18px;
`

const StyledSpanForValue = styled.span`
  font-weight: 400;
  font-size: 16px;
`

const ProfileView = ({
  profileData,
  onEditClick,
  t,
  phoneUpdated,
  nameUpdated,
  checkMarkCompleteStatus,
}) => {
  return (
    <Table borderless size="sm">
      <tbody>
        {[
          { label: `${profileData.firstName} ${profileData.lastName}`, field: 'fullName' },
          {
            label: `${t('my_profile.mobile')}: `,
            value: profileData.mobileNumber,
            field: 'mobileNumber',
          },
          {
            label: `${t('my_profile.email')}: `,
            value: profileData.emailAddress,
            field: 'emailAddress',
          },
        ].map(({ label, value, field }) => (
          <StyledRow key={field}>
            <td style={{ verticalAlign: 'middle', wordBreak: 'break-word' }}>
              {field === 'fullName' ? (
                <StyledFullNameSpan>{label}</StyledFullNameSpan>
              ) : (
                <StyledSpan>{label}</StyledSpan>
              )}
              <StyledSpanForValue>{value}</StyledSpanForValue>
              {((field === 'fullName' && nameUpdated) ||
                (field === 'mobileNumber' && phoneUpdated)) && (
                <CheckMark
                  color={colors.primary_green}
                  size="lg"
                  delay="10000"
                  onComplete={checkMarkCompleteStatus}
                />
              )}
            </td>
            <td style={{ verticalAlign: 'middle', textAlign: 'right', width: '1%' }}>
              <SVGIcon
                Icon={Pencil}
                size="lg"
                color={colors.primary_blue}
                onClick={() => onEditClick(field)}
                aria-label={`Edit ${field}`}
              />
            </td>
          </StyledRow>
        ))}
      </tbody>
    </Table>
  )
}

const profileData = PropTypes.shape({
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  mobileNumber: PropTypes.string.isRequired,
  emailAddress: PropTypes.string.isRequired,
})

ProfileView.propTypes = {
  profileData: profileData.isRequired,
  onEditClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  phoneUpdated: PropTypes.bool.isRequired,
  nameUpdated: PropTypes.bool.isRequired,
  checkMarkCompleteStatus: PropTypes.func.isRequired,
}

export default ProfileView
